import type { User as UserTable } from '@/types/tower/v2/User';

export interface User {
  sub: string;
  email: string;
  name: string;
  phone: string;
  identity: string;
  roles: string[];
  permissions: string[];
  allAccountsAllowed: boolean;
  allowedAccounts?: UserAccountPermission[];
  allowedCarrierIds?: number[];
  allowedWholesalerIds?: number[];
  mfaEnabled: boolean;
  hasSalesforceAccess: boolean;
  legalDisclaimerAccepted?: boolean;
  user: UserTable;
  clientId: string;
  correlationId: string;
  apiVersion?: string;

  /**
   * @deprecated Use `IsUserAClient` instead
   * */
  isExternalClient: boolean;
}

export interface UserAccountPermission {
  accountId: number;
  isParent: boolean;
}

export interface UserProfilePatchRequest {
  phone?: string;
  mfaEnabled: boolean;
}

export interface HomepagePreferencePatchRequest {
  homepagePath: string;
}

export interface UserProfile {
  phone?: string;
  mfaEnabled: boolean;
}

export enum UserType {
  SSO = 1,
  Manual = 2,
}

export interface ExternalUser {
  id: string;
  email: string;
  name?: string;
  lastActive?: string;
}

export enum UserModalType {
  Create = 'create',
  Update = 'update',
}
